<template>
  <div class="container">
    <div class="image-container">
      <el-image class="banner-image"
                :src="src"
                fit="fill">
        <div slot="placeholder"
             class="image-slot">
        </div>
      </el-image>
    </div>
    <div class="top-menu">
      <top-menu />
    </div>
    <div class="title-container">
      <h1 class="title">美团地图开放平台 全新上线</h1>
      <h2 class="sub-title">
        美团地图为开发者提供丰富地图服务，助力业务稳健发展
      </h2>
    </div>
    <footer class="footer">
      <div class="item-container">
        <div style="width:100%;border-right:1px solid rgba(255,255,255,0.12); cursor: pointer;"
             @click="goRouter('/notice/announce')">
          <div class="footer-title-container">
            <h3 class="footer-title">公告中心</h3>
            <el-image :src="srcNoticeIcon"></el-image>
          </div>
          <h4 class="footer-sub-title">美团地图开放平台上线</h4>
        </div>
      </div>
      <div class="item-container"
           @click="goRouter('/notice/guide')">
        <div style="width:100%; cursor: pointer;"
             @click="goRouter('/notice/guide')">
          <div class="footer-title-container">
            <h3 class="footer-title">合规指南</h3>
            <el-image :src="srcNoticeIcon"></el-image>
          </div>
          <h4 class="footer-sub-title">开发者合规指引及建议</h4>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import TopMenu from '../TopMenu';
export default {
  data() {
    return {
      src: require('@/assets/img/home/banner-image.png'),
      srcNoticeIcon: require('@/assets/img/home/icon-notice-arrow.svg'),
      src_logo: require('@/assets/img/meituan-logo.png')
    };
  },
  methods: {
    onClick() {
      this.$router.push('/profile');
    },
    goRouter(path) {
      this.$router.push(path);
    }
  },
  components: {
    TopMenu
  }
};
</script>
<style lang="less" scoped>
.container {
  position: relative;
  width: 100%;
  height: 568px;
  background: #000;
  .image-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    .image-slot{
      width: 1440px;
      background-color: transparent;
    }
  }
  .banner-image {
    height: 100%;
    width: 1440px;
  }
  .top-menu {
    position: absolute;
    width: 100%;
    height: 60px;
    display: flex;
    justify-content: center;
  }
  .top-menu:hover{
    background: rgba(255,255,255,0.03);
  }
  .title-container {
    width: 1200px;
    position: absolute;
    padding-left: 60px;
    top: 160px;
    left: 50%;
    transform: translateX(-50%);
    .title {
      font-family: MeituanType-Regular;
      font-size: 42px;
      color: #fff;
      font-weight: 400;
      line-height: 59px
      // position: absolute;
      // top: 160px;
      // left: 180px;
    }
    .sub-title {
      margin-top: 18px;
      font-family: MeituanType-Regular;
      font-size: 18px;
      color: rgba(255, 255, 255, 0.72);
      font-weight: 200;
      line-height: 25px
      // position: absolute;
      // top: 237px;
      // left: 180px;
    }
  }

  .yello-btn {
    width: 180px;
    background: #ffd100;
    border-radius: 40px;
    font-size: 18px;
    color: rgba(0, 0, 0, 0.84);
    font-weight: 600;
    line-height: 25px;
    padding: 9px 0;
    position: absolute;
    top: 322px;
    left: 180px;
    border: none;
    cursor: pointer;
  }
  .footer {
    position: absolute;
    width: 100%;
    bottom: 0;
    background: rgba(255, 255, 255, 0.06);
    display: flex;
    justify-content: center;
    .item-container {
      width: 600px;
      height: 88px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      text-align: center;
    }
    .item-container:hover{
      background-color: rgba(255,255,255,0.06);
    }
    .footer-title-container{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 25px;
      h3{
        font-family: PingFangSC-Medium;
        font-size: 18px;
        color: rgba(255,255,255,1);
        font-weight: 500;
        line-height: 25px;
        margin-top: 0px;
      }
      .el-image{
        margin-left: 6px;
        height: 25px;
        display: flex;
        align-items: center;
      }
    }
    .footer-sub-title{
         margin-top: 6px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.84);
          font-weight: 400;
          line-height: 20px;
    }
  }
  // .footer-title {
  //   margin-top: 19px;
  //   font-size: 18px;
  //   color: #fff;
  //   font-weight: 500;
  //   line-height: 25px;
  //   span {
  //     display: inline-block;
  //     height: 18px;
  //     width: 18px;
  //     font-size: 14px;
  //     background: rgba(255, 255, 255, 0.12);
  //     border-radius: 3.5px;
  //     border: none;
  //     line-height: 25px;
  //     cursor: pointer;
  //   }
  // }
  // .footer-sub-title {
  //   margin-top: 6px;
  //   font-size: 14px;
  //   color: rgba(255, 255, 255, 0.84);
  //   font-weight: 400;
  //   line-height: 20px;
  // }
}
</style>

<style >
.yello-btn:hover {
  background-color: #ffd92e !important;
}
</style>
